import { GetStaticPaths, GetStaticProps } from 'next';

import { generatedPagesFolder } from 'libs/cms/common/paths';
import slugToApisDocsPageProps from 'libs/cms/parse/apis/slugToApisDocsPageProps';
import getPagePaths from 'libs/cms/parse/getPagePaths';
import { toNextPath } from 'libs/cms/parse/slugUtils';
import CmsPage, { CmsPageProps } from 'pages/CmsPage';
import { MissingParams } from 'utils/slugs';

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await getDocsPaths();

  return {
    paths: paths.map(toNextPath),
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<CmsPageProps> = async ({
  params,
}) => {
  if (!params || !params.slug) throw new MissingParams();

  const pageProps = await slugToApisDocsPageProps(params.slug);

  return {
    props: { ...pageProps, pathPrefix: 'apis/docs/' },
  };
};

const getDocsPaths = async () => {
  const docsDir = `${generatedPagesFolder}/apis/docs`;
  const fullPaths = await getPagePaths(docsDir);

  return fullPaths
    .filter((page) => page !== 'apis/docs/fleet-overview')
    .filter((page) => page !== 'apis/docs/fleet-streamed-data')
    .map((path) => path.replace('apis/docs/', ''));
};

export default CmsPage;
